import React from "react";
import { Route } from "react-router-dom";
import AccessControl from "../../../components/utilities/Class/AccessControl";
import WorkSheet from "../../../containers/modules/report/work-sheet";

export default function WorkSheetRoutes(props) {
  const { authUser } = props;
  return (
    <Route
      path="work-sheet"
      index
      element={
        <AccessControl
          name={"Work Sheet Show"}
          auth={authUser}
          component={() => <WorkSheet />}
        />
      }
    ></Route>
  );
}
